import {DATASET_MIXPANEL, ResourceType} from 'common/report/constants';
import type {TopTypesResponse} from 'common/report/queries/query-api/types';
import {LocalizationStore} from 'common/i18n/store';

import {queryApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';
import {getEventParam, processProperties} from './utils';

export class EventPropertiesClient extends BaseClient<ReturnType<typeof processProperties>> {
  declare i18n: LocalizationStore;

  constructor(i18n: LocalizationStore) {
    super();
    this.i18n = i18n;
  }

  buildEndpoint() {
    return queryApiUrl(`events/properties/toptypes/`);
  }

  buildQueryParams(options: {projectId: number}) {
    return {
      project_id: options.projectId,
    };
  }

  buildRequestBody(
    options = {includeDimensionProperties: false, includeHidden: false, objectProperty: null, workspaceId: null},
  ) {
    const {
      eventName,
      datasetId,
      dataGroupId,
      includeCustom,
      includeDimensionProperties,
      includeHidden,
      objectProperty,
      workspaceId,
      property = null,
      useQueryCache = null,
    } = {
      eventName: null,
      datasetId: DATASET_MIXPANEL,
      dataGroupId: null,
      includeCustom: false,
      ...options,
    };
    /* eslint-disable camelcase */
    return JSON.stringify({
      limit: 1500,
      ...getEventParam(eventName),
      ...(datasetId !== DATASET_MIXPANEL ? {dataset_name: datasetId} : {}),
      ...(dataGroupId ? {data_group_id: dataGroupId} : {}),
      ...(includeCustom ? {include_custom: includeCustom} : {}),
      ...(includeDimensionProperties ? {include_dimension_props: includeDimensionProperties} : {}),
      ...(includeHidden ? {include_hidden: includeHidden} : {}),
      ...(objectProperty ? {object_property: JSON.stringify(objectProperty)} : {}),
      ...(workspaceId ? {workspace_id: workspaceId} : {}),
      ...(property ? {property: JSON.stringify(property)} : {}),
      ...(useQueryCache !== null ? {use_query_cache: useQueryCache} : {}),
    });
    /* eslint-enable camelcase */
  }

  processResponse(response: TopTypesResponse, params: {objectProperty?: unknown; property?: unknown} = {}) {
    return processProperties(response, ResourceType.Event, this.i18n, {
      // Results for an object property (or a list property's items) are the
      // objects' bare inner keys, not top-level property names.
      areObjectInnerKeys: Boolean(params.objectProperty || params.property),
    });
  }
}
